<template>
  <div class="order">
    <NavBarVue title="确认订单"/>
    <div class="order-top clearfix topBg">
      <div class="user" @click="goPersonal">
        <div class="user-left">
          <div class="bed">
            {{ bedName }}
          </div>
          <div class="info">
            <span>{{ userName }}</span>
            <span>{{ userMobile }}</span>
          </div>
        </div>
        <div class="user-right">
<!--          <img src="../assets/images/me/next.png" alt="">-->
        </div>
      </div>
    </div>
    <div class="order-info">
      <div class="order-wrap">
        <div class="order-list">
          <div class="order-item" v-for="(item,index) in cartList" :key="index">
            <div class="left">
              <div class="img">
                <img :src="item.image" alt="">
              </div>
              <div class="info">
                <div class="text">
                  <span class="name oneClampEllipsisType1">{{ item.goodsName }}</span>
                  <span class="remark twoClampEllipsis" style="line-height: 1">{{ item.remark }}</span>
                </div>
                <div class="num">x {{ item.num }}</div>
              </div>
            </div>
            <div class="right">
              ￥{{ item.amount }}
            </div>
          </div>
        </div>
        <div class="total box">
          <div>
            <span>共 {{ totalNum }} 件</span>
            <span>小计￥</span>
            <span>{{ totalAmount }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="payment">
      <div class="box">
        <div class="payment-type" v-if="balance>0">
          <span class="balance">余额支付<i>(余额：￥{{ balance }})</i></span>
          <div class="balance-type">
            <span v-if="payType">￥ -{{ balanceAmount }}</span>
            <div class="choose" @click="getGoodsInfo">
              <span v-if="payType"></span>
            </div>
          </div>
        </div>
        <div class="payment-type">
          <span>支付方式</span>
          <div class="wx">
            <span>微信支付</span>
            <img src="../assets/images/me/next.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="payment-box">
      <div class="price">
        <span>应付￥</span>
        <span>{{ meet }}</span>
      </div>
      <div class="goPayment" @click="createOrder">去支付</div>
    </div>
  </div>
</template>

<script>
import NavBarVue from '../components/NavBar.vue';
import {Toast} from "vant";
import wxPay from "../utils/wxPay";

export default {
  components: {
    NavBarVue,
  },
  data() {
    return {
      bedName: "",
      userName: "",
      userMobile: "",
      balance: '0.00',
      cartList: [],
      totalAmount: 0,
      totalNum: 0,
      balanceAmount: 0,
      payType: true,//true余额支付,false不使用
      orderId: null,
      meet: 0,
      createdOrder: false,//防止多次点击报错
    };
  },
  created() {
    if (this.$route.query.orderId) {
      this.orderId = this.$route.query.orderId
    }
  },
  mounted() {
    this.getGoodsInfo(false);
  },
  methods: {
    //跳转个人中心
    goPersonal() {
      // this.$router.push('/my/personal');
    },
    getGoodsInfo(flag = true) {
      if (flag) {
        this.payType = !this.payType;
      }
      let useBalance;
      if (this.payType) {
        useBalance = 1;
      } else {
        useBalance = 0;
      }
      let data = {
        orderId: this.orderId,
        useBalance
      }
      this.$post('order/checkout', data).then(result => {
        this.cartList = result.data.carts;
        this.totalAmount = result.data.totalAmount;
        this.totalNum = result.data.totalNum;
        this.balanceAmount = result.data.balanceAmount ? result.data.balanceAmount : '0';
        this.meet = result.data.payAmount;

        this.userName = result.data.userName;
        this.balance = result.data.balance ? result.data.balance : '0.00';
        this.bedName = result.data.bedName;
        this.userMobile = result.data.userMobile;
      });
    },
    //创建订单
    createOrder() {
      if (this.createdOrder) {
        return
      }
      let isBalance;
      if (this.payType) {
        isBalance = 1;
      } else {
        isBalance = 0;
      }
      let data = {
        isBalance
      }
      this.$post('order/create', data).then(result => {
        if (result.status === 200) {
          if (result.data.status == 1) {
            window.sessionStorage.setItem("skipAddress", encodeURIComponent(window.location.href));
            this.$router.push('/empower')
            return
          } else {
            this.createdOrder = true;
            this.payOrder(result.data);
          }
        } else {
          Toast(result.msg);
        }
      })
    },
    //支付
    payOrder(orderId) {
      let payType;
      if (this.payType) {
        payType = 1;
      } else {
        payType = 0;
      }
      this.$post('pay/getPayData', {
        orderId,
        payType
      }).then(res => {
        if (res.status === 200) {
          if (res.data.appId) {
            let data = {
              appId: res.data.appId,//公众号id，必传
              nonceStr: res.data.nonceStr,//随机串，必传
              timeStamp: res.data.timeStamp,//时间戳，必传
              package: res.data.package,//必传
              signType: res.data.signType,//微信签名方式
              paySign: res.data.sign,//微信签名
            }
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                    "WeixinJSBridgeReady",
                    wxPay(data, (rec) => {
                      this.$router.replace('/my/orderRecord?orderId=0');
                    }, () => {
                      this.$router.replace('/my/orderRecord?orderId=1');
                    }),
                    false
                );
              } else if (document.attachEvent) {
                document.attachEvent(
                    "WeixinJSBridgeReady",
                    wxPay(data, (rec) => {
                      this.$router.replace('/my/orderRecord?orderId=0');
                    }, () => {
                      this.$router.replace('/my/orderRecord?orderId=1');
                    })
                );
                document.attachEvent(
                    "onWeixinJSBridgeReady",
                    wxPay(data, (rec) => {
                      this.$router.replace('/my/orderRecord?orderId=0');
                    }, () => {
                      this.$router.replace('/my/orderRecord?orderId=1');
                    })
                );
              }
            } else {
              wxPay(data, (rec) => {
                this.$router.replace('/my/orderRecord?orderId=0');
              }, () => {
                this.$router.replace('/my/orderRecord?orderId=1');
              });
            }
          } else {
            Toast('支付成功');
            this.$router.replace('/my/orderRecord?orderId=0');
          }
        } else {
          Toast(res.msg);
        }
      })
    }
  }
}

</script>
<style lang='less' scoped>
.order {
  font-size: 12px;
  padding-bottom: 70px;

  .order-top {
    height: 200px;
    padding: 0 15px;
    box-sizing: border-box;

    .user {
      height: 85px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      box-sizing: border-box;
      color: #999999;
      background: #FFFFFF;
      border-radius: 10px;
      margin-top: 15px;

      .bed {
        font-size: 18px;
        color: #000000;
      }

      .info {
        font-size: 15px;
        margin-top: 15px;

        span:nth-child(2) {
          margin-left: 10px;
        }
      }

      .user-right {
        img {
          width: 9px;
          height: 18px;
        }
      }
    }
  }

  .order-info {
    margin-top: -90px;
    padding: 0 15px;
    box-sizing: border-box;
    overflow: hidden;

    .order-wrap {
      background: #FFFFFF;
      padding: 15px 15px 0 15px;
      box-sizing: border-box;
      border-radius: 10px;

      .order-list {
        padding-bottom: 20px;

        .order-item {
          display: flex;
          position: relative;
          margin-top: 15px;

          .left {
            display: flex;
            align-items: flex-start;
            flex-shrink: 0;

            .img {
              width: 55px;
              height: 55px;
              border-radius: 8px;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .info {
              width: 190px;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              margin-left: 15px;
              overflow: hidden;

              .text {
                width: 100%;
                display: flex;
                flex-direction: column;

                .name {
                  font-size: 15px;
                  font-weight: bold;
                }

                .remark {
                  margin-top: 5px;
                  color: #999999;
                  white-space: normal;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }

              .num {
                color: #999999;
              }
            }
          }

          .right {
            position: absolute;
            right: 0;
            bottom: 0;
            font-size: 15px;
            color: #000000;
          }
        }

        .order-item:first-child {
          margin-top: 0;
        }
      }

      .box {
        height: 47px;
        display: flex;
        align-items: center;
        border-top: 1px solid #DDDDDD;
      }

      .total {
        display: flex;
        justify-content: flex-end;
        color: #000000;

        div {
          display: flex;
          align-items: flex-end;

          span:nth-child(1) {
            color: #999999;
          }

          span:nth-child(2) {
            margin-left: 5px;
          }

          span:nth-child(3) {
            font-size: 18px;
            font-weight: bold;
            margin-left: 5px;
          }
        }
      }
    }
  }

  .payment {
    padding: 0 15px;
    box-sizing: border-box;
    border-radius: 10px;
    margin-top: 15px;

    .box {
      background: #FFFFFF;
      padding: 0 15px;
      box-sizing: border-box;

      .payment-type {
        height: 50%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 15px;
        color: #000000;
        padding: 18px 0;
        border-top: 1px solid #DDDDDD;

        .balance {
          i {
            font-style: normal;
            color: #999999;
            font-size: 12px;
            margin-left: 5px;
          }
        }

        .balance-type, .wx {
          color: #FC3912;
        }

        .wx {
          display: flex;
          align-items: center;

          img {
            width: 9px;
            height: 18px;
            margin-left: 10px;
          }
        }

        .balance-type {
          display: flex;
          align-items: center;

          .choose {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            border: 1px solid #126AFC;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 10px;

            span {
              width: 11px;
              height: 11px;
              border-radius: 50%;
              background: #126AFC;
            }
          }
        }
      }

      .payment-type:first-child {
        border-top: none;
      }
    }
  }

  .payment-box {
    width: 100%;
    height: 60px;
    background: #FFFFFF;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .price {
      display: flex;
      align-items: flex-end;
      margin-right: 18px;

      span:nth-child(1) {
        margin-right: 5px;
      }

      span:nth-child(2) {
        font-size: 20px;
        color: #FC3912;
        font-weight: bold;
      }
    }

    .goPayment {
      margin-right: 15px;
      width: 110px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      font-size: 15px;
      font-weight: bold;
      color: #FFFFFF;
      background: #126AFC;
      border-radius: 20px;
    }
  }
}
</style>